import React, { useContext } from 'react';
import './ModalHeader.css';
import Sticky from '../../Stickyfill/Stickyfill';
import ThemeContext from '../../ThemeContext/ThemeContext';
export function ModalHeader(_ref, ref) {
  var children = _ref.children;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Sticky, null, function (ref) {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: "_modal__child _dm-modal__header _dm-modal__header--".concat(theme, " auto-modal-header")
    }, children);
  });
}
export default React.forwardRef(ModalHeader);